import type { IntercomUserSettings } from "helpers/intercom";

export type IntercomPermissions = {
  intercom_jwt_token?: string;
};

export const resolveIntercomUser = (
  permissions: IntercomPermissions | null | undefined,
): Omit<IntercomUserSettings, "app_id"> | null => {
  if (!permissions?.intercom_jwt_token) {
    return null;
  }

  return {
    intercom_user_jwt: permissions.intercom_jwt_token,
  };
};
